import React from 'react';

interface ReportGadgetContextType {
  reportGadget: ReportGadgets.ReportGadget;
  isEditing: boolean;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReportGadgetContext = React.createContext<ReportGadgetContextType>(
  {} as ReportGadgetContextType,
);

export default ReportGadgetContext;
